export * from './Affiliate';
export * from './OAuth';
export * from './Social';
export * from './Youtube';
export * from './Error';
export * from './Redis';
export * from './payout';
export * from './Dashboard';
export * from './News';
export * from './Talon';

declare global {
    interface Paging {
        total: number;
        count: number;
        start: number;
    }

    interface Elements<D = undefined> {
        elements: D[];
        paging: Paging;
    }

    interface ElementsMap<D extends {}> {
        elements: D;
        paging: Paging;
    }

    type Unpack<T> = T extends (infer U)[] ? U : T;
    type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

    type AsyncReturnType<T extends (...args: any) => Promise<any>> = T extends (
        ...args: any
    ) => Promise<infer R>
        ? R
        : any;

    interface DateRange {
        startDate: Date;
        endDate: Date;
    }

    type DeepReadonly<T> = T extends Function
        ? T
        : T extends readonly (infer R)[]
        ? DeepReadonlyArray<R>
        : T extends Map<infer K, infer V>
        ? DeepReadonlyMap<K, V>
        : T extends object
        ? DeepReadonlyObject<T>
        : T;

    type DeepReadonlyArray<T> = readonly DeepReadonly<T>[];
    type DeepReadonlyMap<K, V> = ReadonlyMap<DeepReadonly<K>, DeepReadonly<V>>;

    type DeepReadonlyObject<T> = {
        readonly [P in keyof T]: DeepReadonly<T[P]>;
    };
}
